<template>
  <component :is="decoratorName">
    <ResetPassword :disable-to-signin='false' />
  </component>
</template>

<script setup lang="ts">
// eslint-disable-next-line no-unused-vars
import ContainerPage from './ContainerPage.vue'
import ResetPassword from './ResetPassword.vue'

import { useLoginStore } from '../DefaultLoginPagePlugin'

const store = useLoginStore()
const decoratorName = store.$state.decoratorComponentName || ContainerPage

</script>

<style scoped lang="less"></style>
